var init = require("init");

init.then(function (init) {
    require("../sass/normalize.scss");
    require("@material/layout-grid/mdc-layout-grid.scss");
    require("@os/typography/typography.scss");
    require("@os/mdc/button.scss");
    require("@os/mdc/layout-grid.scss");
    require("@os/helper/helper.scss");
    require("../sass/survey-header/survey-header.scss");
    require("../sass/survey-thankyou/survey-thankyou.scss");

    var thankYouTemplate = require("../view/survey-thankyou.hbs");

    define([
        "jquery",
        "@os/header",
        "@os/footer",
        "@os/query-string",
        "clipboard",
    ], function ($, header, footer, queryString, ClipboardJS) {
        $(function () {
            var query_string = queryString.parseArguments("survey/thankyou/");
            var survey_id = query_string[0];
            var survey_key = query_string[1];
            var action = query_string[2];

            $.ajax({
                url: "/api/survey/thankyou",
                data: {
                    survey_id: survey_id,
                    survey_key: survey_key,
                },
                method: "POST",
                dataType: "json",
            }).done(function (data) {
                $("#page-content").append(thankYouTemplate(data));

                if ($.trim(action) == "optout") {
                    $.ajax({
                        url: "/api/survey/google/assist/oup/out",
                        type: "post",
                        data: {
                            survey_id: survey_id,
                            survey_key: survey_key,
                        },
                        dataType: "json",
                        context: this,
                    }).done(function (data) {
                        if (data.success) {
                            $(".survey-thankyou__content").hide();
                            $(".survey-thankyou__opt-out-message").show();
                        }
                    });
                }

                $(".survey-thankyou__flex-row.step2").addClass("hidden");

                $(document).on(
                    "click",
                    ".survey-thankyou__flex-row.step2.hidden .clickable-title",
                    function () {
                        $(".survey-thankyou__flex-row.step2").removeClass(
                            "hidden",
                        );
                        $(".survey-thankyou__flex-row.step1").addClass(
                            "hidden",
                        );
                    },
                );
                $(document).on(
                    "click",
                    ".survey-thankyou__flex-row.step1.hidden .clickable-title",
                    function (e) {
                        $(".copy-message-success").hide();
                        $(".survey-thankyou__flex-row.step1").removeClass(
                            "hidden",
                        );
                        $(".survey-thankyou__flex-row.step2").addClass(
                            "hidden",
                        );
                    },
                );

                var clipboard = new ClipboardJS(".copy-button");
                clipboard.on("success", function (e) {
                    $(".survey-thankyou__flex-row.step2").removeClass("hidden");
                    $(".survey-thankyou__flex-row.step1").addClass("hidden");

                    $(".survey-thankyou__flex-row.step1")
                        .find(".clickable-title")
                        .hide();

                    $(e.trigger).next(".copy-message-success").show();
                    //Track comment copied in History...
                    $.ajax({
                        url: "/api/survey/confirmation/copied",
                        type: "post",
                        data: {
                            survey_id: survey_id,
                            survey_key: survey_key,
                        },
                        dataType: "json",
                        success: function (data) {
                            //History log created!
                        },
                    });
                    e.clearSelection();
                });

                clipboard.on("error", function (e) {
                    $(e.trigger).next(".copy-message-error").show();
                });

                $(document).on(
                    "click",
                    'a[data-action="goto-google-review"]',
                    function (event) {
                        $.ajax({
                            url: "/api/survey/confirmation/linked",
                            type: "post",
                            data: {
                                survey_id: survey_id,
                                survey_key: survey_key,
                            },
                            dataType: "json",
                        }).done(function (data) {
                            $("#dialog_google_share").removeClass(
                                "mdc-dialog--open",
                            );
                        });
                    },
                );

                $(document).on(
                    "click",
                    'a[data-action="google-assist-opt-out"]',
                    function (event) {
                        event.preventDefault();
                        event.stopPropagation();

                        $.ajax({
                            url: "/api/survey/google/assist/oup/out",
                            type: "post",
                            data: {
                                survey_id: survey_id,
                                survey_key: survey_key,
                            },
                            dataType: "json",
                            context: this,
                        }).done(function (data) {
                            if (data.success) {
                                $("#dialog_google_share").removeClass(
                                    "mdc-dialog--open",
                                );
                            }
                        });
                    },
                );
            });
        });
    });
});
